import {
    Component,
    Input,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Shipment } from '../../../core/store/models';

@Component({
    selector: 'ah-shipment-input',
    templateUrl: './shipment-input.component.html',
    styleUrls: ['./shipment-input.component.scss'],
    standalone: false
})
export class ShipmentInputComponent {
    @Input() shipment: Shipment;
    @Input() formGroup: UntypedFormGroup;
    @Input() formGroupName: string;

    constructor(public deviceService: DeviceDetectorService) { }
}
